import { render, staticRenderFns } from "./popup-pointer.vue?vue&type=template&id=00847c42&"
import script from "./popup-pointer.vue?vue&type=script&lang=ts&"
export * from "./popup-pointer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00847c42')) {
      api.createRecord('00847c42', component.options)
    } else {
      api.reload('00847c42', component.options)
    }
    module.hot.accept("./popup-pointer.vue?vue&type=template&id=00847c42&", function () {
      api.rerender('00847c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/popup/popup-pointer.vue"
export default component.exports